import { BaseClient } from '../client';
import { TUser } from '../user';
import { UserMock } from '../user/user.mocks';

export const getAdminUserById = async (id: string) => {
	// if (process.env.NODE_ENV === 'development') {
	// 	return UserMock;
	// }

	try {
		const response = await BaseClient.get<TUser[]>(`/Admin/GetAdminUsuarioPorId/${id}`).then(
			(response) => response.data
		);

		return response.at(0)!;
	} catch (error) {
		throw error;
	}
};
